module.exports = __webpack_public_path__ + "assets/media/golovanod_m.9480edc5.jpg";